<template>
  <div class="e-overall e-overall--login e-login">
    <transition name="slide-to-left">
      <div v-show="!offcanvasOpen" class="e-canvas">
        <div v-if="!$route.meta.requiresAuth" class="e-canvas__background" />

        <TheHeader />
        <div class="e-content width-100">
          <div class="e-scroll-container">
            <VuePerfectScrollbar class="e-content__inner center-content">
              <div class="e-content__scroll">
                <div
                  class="e-module e-module--limited e-login-container"
                >
                  <component :is="formType" />
                </div>
              </div>
              <TheFooter class="e-register-footer" />
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-from-right">
      <TheOffcanvas v-show="offcanvasOpen" />
    </transition>

    <el-dialog
      :title="dialogTitle.registered"
      :visible.sync="registerDialog"
      custom-class="el-dialog--small"
    >
      <p
        v-html="
          $route.query.email === '0'
            ? $t('messages.user.register.successNoEmail')
            : $t('messages.user.register.success')
        "
      />

      <span slot="footer" class="dialog-footer">
        <el-button type="tertiary" @click="registerDialog = false">
          {{ $t('system.understood') }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="dialogTitle.activated"
      :visible.sync="activationDialog"
      custom-class="el-dialog--small"
    >
      <p v-html="$t('messages.user.activation.success')" />

      <span slot="footer" class="dialog-footer">
        <el-button type="tertiary" @click="activationDialog = false">
          {{ $t('system.understood') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TheFooter from 'molecules/TheFooter/TheFooter'
import TheHeader from 'molecules/TheHeader/TheHeader'
import LoginForm from 'organisms/Forms/Login/Loginform'
import PasswordForm from 'organisms/Forms/PasswordForgot/PasswordForgot'
import PasswordResetForm from 'organisms/Forms/PasswordReset/PasswordReset'
import ResendConfirm from 'organisms/Forms/ResendConfirm/ResendConfirm'
import UserForm from 'organisms/Forms/UserForgot/UserForgot'
import TheOffcanvas from 'molecules/TheOffcanvas/TheOffcanvas'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    TheFooter,
    TheHeader,
    LoginForm,
    TheOffcanvas,
    PasswordResetForm,
    PasswordForm,
    ResendConfirm,
    UserForm,
    VuePerfectScrollbar
  },
  data() {
    return {
      registerDialog: false,
      activationDialog: false,
      errorMessage: '',
      dialogTitle: {
        registered: this.$t('messages.user.register.successTitle'),
        activated: this.$t('messages.user.activation.title')
      }
    }
  },
  computed: {
    ...mapGetters(['offcanvasOpen', 'userInfo']),
    formType() {
      switch (this.$route.name) {
        case 'forgotPassword':
          return 'PasswordForm'

        case 'resetPassword':
          return 'PasswordResetForm'

        case 'resendConfirmMail':
          return 'ResendConfirm'

        case 'forgotUsername':
          return 'UserForm'

        default:
          return 'LoginForm'
      }
    }
  },
  mounted() {
    if (this.$route.query.registered === 'true') {
      this.registerDialog = true
    } else if (this.$route.query.activated === 'true') {
      this.activationDialog = true
    }
  }
}
</script>

<style lang="scss">
@import '_assets/userlogin';
.e-login {
  .e-login-container {
    background: transparent;
    margin-top: auto;
    margin-bottom: auto;
  }
}
.e-register-footer {
    width: 100%;
  }
.width-100 {
    width: 100%;
  }
  .center-content {
    display: grid;
    place-items: center; 
    }
</style>
